import React from 'react';
import PropTypes from 'prop-types';
import { Divider, List, Paper, Subheader } from 'material-ui';
import style from '../../../styles/styles';
import Error from '../../common/Error/Error';
import RoadBookConfigurationItem from './RoadBookConfigurationItem';

const RoadBookConfigurationList = (props) => {
    const {
        roadBookConfigurations,
        title,
        app,
        currentLang,
    } = props;

    let content = [];
    if (roadBookConfigurations[currentLang]) {
        content = roadBookConfigurations[currentLang];
    }

    return (
        <Paper>
            <List>
                <Subheader style={style.subHeader}>{title}</Subheader>
                {content.length === 0 &&
                    <Error
                        title="No data"
                        subtitle="Add some new road book configurations"
                    />
                }
                {content.length > 0 &&
                    content.sort((a, b) => {
                        return a.created_at - b.created_at;
                    })
                        .map(function (roadBookConfiguration, index) {
                            return <div key={roadBookConfiguration.id}>
                                <RoadBookConfigurationItem
                                    app={app}
                                    roadBookConfiguration={roadBookConfiguration}
                                />
                                {index !== (
                                    roadBookConfigurations.length - 1
                                ) && <Divider inset={true} />}
                            </div>;
                        })
                }
            </List>
        </Paper>
    );
};
RoadBookConfigurationList.propTypes = {
    roadBookConfigurations: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    title: PropTypes.string,
    currentLang: PropTypes.string,
};

export default RoadBookConfigurationList;



// WEBPACK FOOTER //
// src/components/roadbook/RoadBookConfigurationList/RoadBookConfigurationList.js